import { AccountBox, CardGiftcard, Store } from '@mui/icons-material';

export const UserPlan = [
	{
		name: 'ANNUAL PLAN',
		price: '$12.50',
		frequency: 'month',
		description: '$149.99 billed yearly',
		feature: 'Access our full video library'
	},
	{
		name: 'MONTHLY PLAN',
		price: '$19.99',
		frequency: 'month',
		feature: 'Access our full video library'
	}
];

export const StudioPlan = [
	{
		name: 'STUDIO PLAN FOR 5 SEATS',
		price: '$499.00',
		seats: 5,
		description: 'Forever',
		feature: [
			'Account owner + 4 additional seats',
			'FREE 30-minute Zoom call with studio owner & faculty',
			'Studio Playlists',
			'Priority Support',
			'Add and manage your teachers',
			'Studio Metrics: insights from your own studio',
			'Studio Hub: immediate access to all teacher resources'
		]
	},
	{
		name: 'STUDIO PLAN FOR 10 SEATS',
		price: '$749.00',
		seats: 10,
		description: 'Forever',
		feature: [
			'Account owner + 9 additional seats',
			'FREE 30-minute Zoom call with studio owner & faculty',
			'Studio Playlists',
			'Priority Support',
			'Add and manage your teachers',
			'Studio Metrics: insights from your own studio',
			'Studio Hub: immediate access to all teacher resources'
		]
	}
];

export const MONTHLY_PLANS = [
	{
		id: 'INDIVIDUAL-Monthly',
		icon: AccountBox,
		title: 'Standard',
		hasSeatSelection: false,
		price: 19.99,
		cbItem: 'individual-monthly',
		perks: {
			title: 'Includes',
			features: [
				'3-day free trial',
				'Exercises, Lessons, & Across The Floor Videos',
				'Personal & Featured Playlists',
				'Access on any device'
			]
		}
	},
	{
		id: 'VIP-Monthly',
		icon: CardGiftcard,
		title: 'Plus',
		description: 'TRAIN SMARTER WITH COMPLETE ACCESS',
		hasSeatSelection: false,
		price: 34.99,
		cbItem: 'On-Demand-Plus-USD-Monthly',
		perks: {
			title: 'Includes ALL Standard plan features, PLUS',
			features: [
				'3-day free trial',
				'Flexibility Classes',
				'Access to Full Library of Videos',
				'Strength & Technique Classes',
				'6 New Videos Monthly',
				'Teacher Resource Center for teachers (apply in the app)'
			]
		}
	},
	{
		id: 'STUDIO-Monthly',
		icon: Store,
		title: 'Studio Plan',
		hasSeatSelection: true,
		seats: [
			{
				seatId: 'Studio-Account-5',
				seatLabel: '5 Seats',
				price: 74.99,
				cbItem: 'Studio-Account-5-USD-Monthly',
				perks: {
					title: 'Exclusive features for Studios Plan, includes',
					features: [
						'Account owner + 4 additional seats',
						'Studio Playlists',
						'Priority Support',
						'Add and manage your teachers',
						'Studio Metrics: insights from your own studio',
						'Studio Hub: immediate access to all teacher resources'
					]
				}
			},
			{
				seatId: 'Studio-Account-10',
				seatLabel: '10 Seats',
				price: 114.99,
				cbItem: 'Studio-Account-10-USD-Monthly',
				perks: {
					title: 'Exclusive features for Studios Plan, includes',
					features: [
						'Account owner + 9 additional seats',
						'Studio Playlists',
						'Priority Support',
						'Add and manage your teachers',
						'Studio Metrics: insights from your own studio',
						'Studio Hub: immediate access to all teacher resources'
					]
				}
			}
		]
	}
];

export const YEARLY_PLANS = [
	{
		id: 'INDIVIDUAL-Yearly',
		icon: AccountBox,
		title: 'Standard',
		hasSeatSelection: false,
		price: 149.99,
		cbItem: 'on-demand-individual-yearly',
		perks: {
			title: 'Includes',
			features: [
				'7-day free trial',
				'Exercises, Lessons, & Across The Floor Videos',
				'Personal & Featured Playlists',
				'Access on any device'
			]
		}
	},
	{
		id: 'VIP-Yearly',
		icon: CardGiftcard,
		title: 'Plus',
		description: 'TRAIN SMARTER WITH COMPLETE ACCESS',
		hasSeatSelection: false,
		price: 249.99,
		cbItem: 'On-Demand-Plus-USD-Yearly',
		perks: {
			title: 'Includes ALL Standard plan features, PLUS',
			features: [
				'7-day free trial',
				'Flexibility Classes',
				'Access to Full Library of Videos',
				'Strength & Technique Classes',
				'6 New Videos Monthly',
				'Teacher Resource Center for teachers (apply in the app)'
			]
		}
	},
	{
		id: 'STUDIO-Yearly',
		icon: Store,
		title: 'Studio Plan',
		hasSeatSelection: true,
		seats: [
			{
				seatId: 'Studio-Account-5',
				seatLabel: '5 Seats',
				price: 499,
				cbItem: 'studio-plan-5-seats-USD-Yearly',
				perks: {
					title: 'Exclusive features for Studios Plan, includes',
					features: [
						'Account owner + 4 additional seats',
						'FREE 30-minute Zoom call with studio owner & faculty',
						'Studio Playlists',
						'Priority Support',
						'Add and manage your teachers',
						'Studio Metrics: insights from your own studio',
						'Studio Hub: immediate access to all teacher resources'
					]
				}
			},
			{
				seatId: 'Studio-Account-10',
				seatLabel: '10 Seats',
				price: 749,
				cbItem: 'studio-plan-10-seats-USD-Yearly',
				perks: {
					title: 'Exclusive features for Studios Plan, includes',
					features: [
						'Account owner + 9 additional seats',
						'FREE 30-minute Zoom call with studio owner & faculty',
						'Studio Playlists',
						'Priority Support',
						'Add and manage your teachers',
						'Studio Metrics: insights from your own studio',
						'Studio Hub: immediate access to all teacher resources'
					]
				}
			}
		]
	}
];
